import { useLayoutEffect } from "react";
import { withRouter } from "react-router-dom";

function ScrollToTop({ location }) {
  useLayoutEffect(() => {
    document.documentElement.style.scrollBehavior = "auto";
    document.body.style.scrollBehavior = "auto";

    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

export default withRouter(ScrollToTop);